<template>
  <v-container fluid class="my-4" v-if="visibleMapa==true" >
    <v-card class="pa-2 campaign-card" elevation="2">
      <!-- Capçalera amb degradat -->
      <div
        class="d-flex align-center justify-space-between pa-2"
        >
        <!-- Títol -->
        <span class="text-h7 font-weight-bold ">
          MAPA DE REPARTO
        </span>

        <!-- Botons -->
        <div>
          <v-btn
            v-if="!minimitzatMapa"
            size="small"
            variant="text"
            icon="mdi-window-minimize"
            class=""
            @click="minimitzatMapa = true"
          />
          <v-btn
            v-else
            size="small"
            variant="text"
            icon="mdi-window-maximize"
            class=""
            @click="minimitzatMapa = false"
          />
        </div>
      </div>

      <!-- Contingut condicional -->
      <div>
        <iframe
          v-show="!minimitzatMapa"
          :src="urlMapa"
          width = "100%"
          height="765"
          style="border:0;"
          allowfullscreen=""
          loading="lazy"
        ></iframe>
      </div>
    </v-card>
  </v-container>
</template>

<script setup>
import { ref, watch } from 'vue'

// Props → el component rep la URL des del pare
const props = defineProps({
  urlMapa: {
    type: String,
    required: true
  },
  startMinimized: {
    type: Boolean,
    required: true
  },
  visibleMapa : {
    type: Boolean,
    required: true
  },
})

const minimitzatMapa = ref(props.startMinimized)
const visibleMapa= ref(props.visibleMapa)

// 🔁 sincronitza quan el pare canvii
watch(() => props.startMinimized, (v) => {
  minimitzatMapa.value = v
})

watch(() => props.visibleMapa, (v) => {
  visibleMapa.value = v
})

</script>
